module.exports = __webpack_public_path__ + "static/media/BANANA-EPS-BNB.52655944.svg";